// pages/_app.tsx
import type { AppProps } from "next/app";
import "./globals.css"; // Import global styles here

export default function ShenheApp({ Component, pageProps }: AppProps) {
  return (
    <>
      <main>
        <Component {...pageProps} /> {/* This renders the current page */}
      </main>
    </>
  );
}
